import { useMemo } from 'react';

export function primeiroNome(nome = '') {
  return nome.trim().split(/\s+/)[0];
}

export function saudacao() {
  const hora = new Date().getHours();
  if (hora < 12) return 'Bom dia';
  if (hora < 18) return 'Boa tarde';
  return 'Boa noite';
}

export function diasRestantesAte(iso) {
  if (!iso) return null;
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  return Math.round((new Date(iso) - hoje) / 86400000);
}

export function useNomePorHospital(hospitais) {
  return useMemo(() => {
    const mapa = new Map();
    hospitais.forEach((h) => mapa.set(h.id_hospital, h.nome));
    return mapa;
  }, [hospitais]);
}
